import React from 'react'
import PropTypes from 'prop-types'

import { CloningStatusEnum } from '../../constants'

const CloningStatusLabel = ({ status }) => {
  const classNamesDict = {}
  classNamesDict[CloningStatusEnum.IN_PROGRESS] = 'cls-status-in-progress'
  classNamesDict[CloningStatusEnum.ERROR] = 'cls-status-error'
  classNamesDict[CloningStatusEnum.COMPLETED] = 'cls-status-completed'
  classNamesDict[CloningStatusEnum.DRAFT] = 'cls-status-draft'
  classNamesDict[CloningStatusEnum.SCHEDULED] = 'cls-status-scheduled'
  classNamesDict[CloningStatusEnum.TIMEOUT] = 'cls-status-timeout'

  return (
    <span className={classNamesDict[status]}>
      {window.I18n.t(`clone_leagues_sessions.status.${status}`)}
    </span>
  )
}

CloningStatusLabel.propTypes = {
  status: PropTypes.oneOf(Object.values(CloningStatusEnum)).isRequired,
}

export default CloningStatusLabel
